import React from "react";
import { CustomTitleLabel } from "./CustomBaseComponments";
import CustomTips from "components/base/CustomTips";
import MultipleInputWithTitle from "components/base/MultipleInputWithTitle";

const GlobalSettingPeTransactionSection = ({
  hasEditPermission,
  formValue,
  setFormValue,
}) => {
  return (
    <div className="global-setting-prompt-tab-content">
      <CustomTitleLabel
        title={
          <div className="d-flex">
            {"MAXIMUM REWARD PER TRANSACTION (OPTIONAL)"}
            <CustomTips
              popoverClassName="tips-popover"
              detail={"When a transaction exceed the maximum reward limit. \nIf the reward is an one-off fixed amount reward, the reward will NOT be issued.\nIf the reward is a dynamic amount reward, the reward will be issued based on the remaining reward quota."}
            />
          </div>
        }
        className={"customer-detail-section-title"}
      />
      <div className="create-section-field-input">
        {"This section allows you to set the global maximum limit for each transaction. All fields are optional."}
      </div>
      <MultipleInputWithTitle
        title={"Max amount of rewards"}
        inputAreaCustomClass={""}
        inputConfig={[
          {
            value: formValue?.maxAmountOfCoupons,
            unit: "Coupons",
            setValue: (value) => {
              setFormValue({ ...formValue, maxAmountOfCoupons: value })
            },
          },
          {
            value: formValue?.maxAmountOfPoints,
            unit: "Points",
            setValue: (value) => {
              setFormValue({ ...formValue, maxAmountOfPoints: value })
            },
          },
          {
            value: formValue?.maxAmountOfPp,
            unit: "Progression points",
            setValue: (value) => {
              setFormValue({ ...formValue, maxAmountOfPp: value })
            },
          },
          {
            value: formValue?.maxAmountOfStamps,
            unit: "Stamps",
            setValue: (value) => {
              setFormValue({ ...formValue, maxAmountOfStamps: value })
            },
          },
        ].map(item => ({
          ...item, customClass: "width-160px", type: "number", disabled: !hasEditPermission,
        }))}
      />
    </div>
  )
}


export default GlobalSettingPeTransactionSection